import ProductAppTheme from './ProductAppTheme';

export default ProductAppTheme;
